import { base64Encode } from '@cred/react-analytics/utils/data'

const generateBase64String = (params) => base64Encode(JSON.stringify(params))

export const getMetaQuery = (params, theme) => {
  const base64EncodedString = generateBase64String(params)
  const isFox = ['fox', 'fox1'].includes(theme)

  // Only return the generated Base64 encoded string for Fox theme
  return isFox ? `&meta=${base64EncodedString}` : ''
}

export const getMetaParamsFromQuery = (search) => {
  const {
    meta_contentId: contentId,
    meta_articleTitle: articleTitle,
    meta_articleTags: articleTags,
    meta_segmentId: segmentId,
    meta_campaignCode: campaignCode,
    meta_contentDistributor: contentDistributor,
    meta_contentCategory: contentCategory,
    meta_campaignCodeExt: campaignCodeExt,
  } = search

  return {
    contentId,
    articleTitle,
    articleTags,
    segmentId,
    campaignCode,
    contentDistributor,
    contentCategory,
    campaignCodeExt,
  }
}

export const removeEmptyValues = (obj) => {
  return Object.keys(obj || {}).reduce((acc, key) => {
    return obj[key] ? { ...acc, [key]: obj[key] } : { ...acc }
  }, {})
}

export const getMarketplaceParam = (marketplace, marketplaces) => {
  const isMultiVertical = marketplace === 'multi-vertical'

  return isMultiVertical ? marketplaces.split(',') : marketplace
}

export const getOtherOptionsParam = (otherOptions) => {
  if (typeof otherOptions !== 'string') return null
  return otherOptions.split(',')
}

export const parseMultiVerticalOptions = (options) => {
  try {
    return JSON.parse(options)
  } catch (_e) {
    return {}
  }
}
